/** Query keys Claude / MCP OAuth authorize attaches to the consent page. */
const CONSENT_QUERY_KEYS = ['client_id', 'redirect_uri', 'code_challenge'] as const;

export function hasMcpConsentQuery(params: { get(name: string): string | null }): boolean {
  return CONSENT_QUERY_KEYS.every((key) => !!params.get(key));
}

/**
 * If Claude (or a misconfigured SiteUrl) dropped the user on `/` or `/home`
 * with authorize query params, rebuild the real consent URL.
 */
export function mcpConsentUrlIfMisrouted(
  url: string,
  stashedConsentUrl?: string | null,
): string | null {
  const [rawPath, rawQuery] = url.split('?');
  let path = (rawPath.split('#')[0] || '/').trim();
  if (!path.startsWith('/')) {
    path = `/${path}`;
  }
  if (path.length > 1 && path.endsWith('/')) {
    path = path.slice(0, -1);
  }

  const onHome = path === '/' || path === '/home';
  const onNestedConsent = path === '/home/mcp/consent';
  const stashed =
    stashedConsentUrl && stashedConsentUrl.startsWith('/mcp/consent') ? stashedConsentUrl : null;
  if (!onHome && !onNestedConsent) {
    return null;
  }

  const query = rawQuery?.split('#')[0] ?? '';
  const params = new URLSearchParams(query);
  const suffix = query ? '?' + query : '';
  if (!hasMcpConsentQuery({ get: (name) => params.get(name) })) {
    if (onNestedConsent) {
      return '/mcp/consent' + suffix;
    }
    return onHome ? stashed : null;
  }

  return '/mcp/consent' + suffix;
}
